import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/store";
import "@/assets/font/iconfont.css";
import "@/assets/font/iconfont";
import {
  Button,
  Icon,
  Sidebar,
  SidebarItem,
  Card,
  Checkbox,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  Popup,
  Form,
  Field,
  RadioGroup,
  Radio,
  Picker,
  DatetimePicker,
  Area,
  Toast,
  Cell,
  CellGroup,
  Tab,
  Tabs,
  Dialog,
  Calendar,
  Sku,
  Loading,
  List,
  Uploader,
} from "vant";

Vue.use(Button)
  .use(Icon)
  .use(Sidebar)
  .use(SidebarItem)
  .use(Card)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Collapse)
  .use(CollapseItem)
  .use(Popup)
  .use(Form)
  .use(Field)
  .use(RadioGroup)
  .use(Picker)
  .use(Area)
  .use(DatetimePicker)
  .use(Toast)
  .use(Cell)
  .use(CellGroup)
  .use(Tab)
  .use(Tabs)
  .use(Dialog)
  .use(Calendar)
  .use(Radio)
  .use(Loading)
  .use(List)
  .use(Uploader)
  .use(Sku);

// 顶部标题
import VueWechatTitle from "vue-wechat-title";

Vue.use(VueWechatTitle);
Vue.config.productionTip = false;

// 引入样式
import "./assets/css/index.scss";
// 引入淘宝适配方案
import "lib-flexible";

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
